<template>
  <b-modal v-model="show" size="lg" centered header-bg-variant="primary" hide-footer :title="`Member List (Promo Code: ${promoCode})`"  @hide="closeModal()">
    <div>
      <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="memberList" :fields="fields" :current-page="currentPage" :per-page="perPage">
        <template v-slot:cell(sn)="data">
          {{data.index+1 + ((currentPage-1)*perPage)}}
        </template>
      </b-table>
      <nav>
        <b-pagination :total-rows="getRowCount(memberList)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
      </nav>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'MemberListModal',
  props: {
    showMemberListModal: {
      type: Boolean,
      default: false
    },
    promoCode: {
      type: String,
      default: ''
    },
    memberList: {
      type: Array,
      default: []
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fields: [
        {key: 'sn', label: 'S.No'},
        {key: 'Username', label: 'Username'},
        {key: 'AddTime', label: 'Add Time'}
      ],
      currentPage: 1,
      perPage: 20
    }
  },
  computed: {
    show: {
      get: function () {
        return this.showMemberListModal
      },
      set: function () {
        return this.showMemberListModal
      }
    }
  },
  methods: {
    getRowCount (item) {
      return item.length
    },
    closeModal () {
      this.$emit('closeModal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/promotion/promoCode/MemberList.vue